import React from 'react'

export default function User({ className }) {
  return (
    <svg
      viewBox="0 0 15 19"
      className={className}
      style={{ transform: 'scale(.8)' }}
    >
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M5.093 18.265c.555.41 1.002.541 2.516.541 1.131 0 2.474-.492 2.922-.886.448-.394 1.642-1.558 1.642-1.558l-.021 2.083c1.429-1.099 1.535-2.133 1.535-2.493v-3.577c1.493-1.247 1.066-2.658 1.066-3.051V3.018S15.308 0 7.716 0 .167 2.461.167 3.183v6.731c0 1.87 1.023 2.363 1.023 2.363v3.609c0 1.837 1.969 2.592 1.969 2.592v-1.772s1.38 1.149 1.934 1.559zm-3.118-5.463v-2.166-2.887c0-.821.282-2.002 1.561-2.002h2.09l-2.26 5.348 2.943-1.181L4 16l9-9-4.815 1.372 1.578-2.625h1.706c.768 0 1.451.328 1.451 1.411v6.333c0 .951-.406 1.591-1.067 2.1-.661.508-2.004 2.329-4.03 2.329-2.026 0-2.396-.065-4.664-2.329-.646-.755-1.184-1.116-1.184-2.789z"
      />
    </svg>
  )
}
